import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '@shared/services/common-service';
import { GetConfigKanbanResponse } from '@shared/services/responses/servico/get-config-kanban.response';
import { ConfigKanbanLookupsResponse } from '@shared/services/responses/servico/config-kanban-lookups.response';
import { EtapaKanbanSalvarRequest } from '@shared/services/requests/servico/etapa-kanban-salvar.request';
import { EtapaKanbanExcluirRequest } from '@shared/services/requests/servico/etapa-kanban-excluir.request';
import { KanbanReordenarRequest } from '@shared/services/requests/servico/kanban-reordenar.request';
import { EtapaKanbanAtivoRequest } from '@shared/services/requests/servico/etapa-kanban-ativo.request';
import { ReturnStruct } from '@shared/services/structs/return.struct';

@Injectable({
  providedIn: 'root',
})
export class ConfigKanbanService extends CommonService {
  private readonly apiUrl: string = environment.urlApiServico + 'ConfigKanban';

  constructor(private httpClient: HttpClient) {
    super();
  }

  public get(): Observable<GetConfigKanbanResponse> {
    return this.httpClient
      .get<GetConfigKanbanResponse>(this.apiUrl, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getLookups(): Observable<ConfigKanbanLookupsResponse> {
    return this.httpClient
      .get<ConfigKanbanLookupsResponse>(`${this.apiUrl}/lookups`, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public salvarEtapa(request: EtapaKanbanSalvarRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/etapa/salvar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public excluirEtapa(request: EtapaKanbanExcluirRequest): Observable<ReturnStruct> {
    return this.httpClient
      .post<ReturnStruct>(`${this.apiUrl}/etapa/excluir`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public toggleAtivo(idEtapaKanban: number, request: EtapaKanbanAtivoRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(
        `${this.apiUrl}/etapa/idEtapaKanban/${idEtapaKanban}/ativo`,
        request,
        this.addHeaderToken()
      )
      .pipe(catchError(this.handleError));
  }

  public reordenar(request: KanbanReordenarRequest): Observable<ReturnStruct> {
    return this.httpClient
      .put<ReturnStruct>(`${this.apiUrl}/reordenar`, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }
}
